import React from "react";
import { Helmet } from "react-helmet-async";
import { useCase } from "../../provider/CaseProvider.tsx";
import { getCaseLabel } from "../../services/Product/ProductService/productService.ts";

export default function CaseHelmet() {

  const { product } = useCase();

  if (!product) {
    return null;
  }

  return (
    <Helmet>
      <title>{`${getCaseLabel(product)} | Legalbird`}</title>
    </Helmet>
  );
};
